/**
 * @prop --wf-newsletter-subscription-background-color: The background color of the newsletter box.
 * @prop --wf-newsletter-subscription-border-radius: The border radius of the button and input.
 */
:host {
    display: flex;
    flex-direction: column;
    padding: 40px 16px;
    gap: 24px;
    background-color: var(--wf-newsletter-subscription-background-color, #000);
    color: #fff;
}

.content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 40px;
}

.catch-title {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    font-stretch: normal;
    font-style: normal;
    font-weight: 900;

    &-row-1 {
        font-size: 130px;
        line-height: 1;
        letter-spacing: -9.75px;
    }

    &-row-2 {
        text-transform: uppercase;
        font-size: 36px;
        line-height: 0.69;
        letter-spacing: -1.08px;
    }
}

form {
    flex: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;

    input {
        background-color: #fff;
        height: 54px;
        border-radius: var(--wf-newsletter-subscription-border-radius, 4px);
        border: 1px solid rgb(0 0 0 / 20%);
        font-size: 16px;
        line-height: 1.25;
        padding: 0 16px;
        width: inherit;
    }
}

.newsletter-disclaimer {
    color: rgb(255 255 255 / 50%);
    font-size: 12px;
    line-height: 1.67;
}

a {
    color: currentcolor;
}


.newsletter-content {
    &-title {
        font-size: 22px;
        font-weight: 500;
        line-height: 1.27;
        margin-bottom: 8px;
    }

    &-text {
        font-size: 16px;
        line-height: 1.25;

        div::before {
            content: "✓"
        }
    }
}


@media screen and (min-width: 768px) {
    .newsletter-content {
        &-title {
            font-size: 28px;
            line-height: 1.29;
        }
    }
}


@media screen and (min-width: 992px) {
    :host {
        padding: 24px 80px;
    }

    .content-wrapper {
        flex-direction: row;
    }

    .catch-title {
        margin: -28px 0 0;

        &-row-1 {
            font-size: 146px;
            line-height: 1.1;
            letter-spacing: -9.75px;
        }

        &-row-2 {
            text-transform: uppercase;
            font-size: 40px;
            line-height: 0.63;
            letter-spacing: -1.2px;
        }
    }

    form {
        margin-top: 48px;
    }
}
